import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class UserAPI {
  
  static list = (filter, success, failure) => {
    fetch(Config.app.link + 'api/user/list', new Header('POST', { filter }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/user/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (user, success, failure) => {
    fetch(Config.app.link + 'api/user', new Header('POST', user))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deactive = (id, success, failure) => {
    fetch(Config.app.link + 'api/user/deactive/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static active = (id, success, failure) => {
    fetch(Config.app.link + 'api/user/active/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default UserAPI;